import { render } from "./ProfileTestHistoryTable.vue?vue&type=template&id=01bebe76"
import script from "./ProfileTestHistoryTable.vue?vue&type=script&lang=js"
export * from "./ProfileTestHistoryTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__